<div class="container" *ngIf="!currentTab">
    <div class="header">{{ 'system-settings.title' | translate }}</div>
    <div class="general">
        <div class="general-header common-property">
            <div class="title">
                {{ 'system-settings.general.title' | translate }}
            </div>
            <button
                class="edit-button"
                data-cy="ops-settings-system-setting-edit-button"
                (click)="openGeneralDialog()"
                [disabled]="!userCanEdit">
                {{ 'dlg.edit' | translate }}
            </button>
        </div>
        <div class="general-main">
            <div class="common-property">
                <div class="common-title">
                    {{ 'system-settings.general.dialog.input-label.drawing-id' | translate }}
                </div>
                <div class="common-data">{{ vessel.drawingId }}</div>
            </div>
            <div class="common-property">
                <div class="common-title">
                    {{ 'system-settings.general.dialog.input-label.default-language' | translate }}
                </div>
                <div class="common-data">{{ languageLabel | translate }}</div>
            </div>
            <div class="common-property">
                <div class="common-title">
                    {{ 'system-settings.general.dialog.input-label.systems-clock' | translate }}
                </div>
                <div class="common-data">
                    {{ masterClockLabel | translate }}
                </div>
            </div>
            <div class="common-property">
                <div class="common-title">
                    {{ 'system-settings.general.dialog.checkbox-label.utc' | translate }}
                </div>
                <div class="common-data">{{ utcLabel }}</div>
            </div>
            <div class="common-property-boolean" [class.visible]="common?.japanCoastGuard">
                <div class="check-icon-wrapper">
                    <mat-icon svgIcon="check"></mat-icon>
                    <div class="common-data">
                        {{ 'system-settings.general.checkbox.jp-guard' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="tabs">
        <div class="tab" *ngFor="let tab of TABS" (click)="selectTab(tab)">
            <div class="tab-title" data-cy="ops-settings-system-setting-tab-title">
                {{ tab }}
            </div>
            <mat-icon class="icon" svgIcon="chevron-right"></mat-icon>
        </div>
    </div>
</div>

<div class="container setting" *ngIf="currentTab">
    <div class="setting-header">
        <div class="tab-small-title">
            <mat-icon
                class="chevron-left"
                data-cy="ops-settings-system-setting-tab-back-icon"
                svgIcon="chevron-right"
                (click)="selectTab(DEFAULT)"></mat-icon>
            <div class="setting-title">
                {{ currentTab }}
            </div>
        </div>
        <button
            class="save-button"
            *ngIf="currentTab === EAP"
            data-cy="ops-settings-system-setting-eap-save-button"
            (click)="saveTab(currentTab)"
            [disabled]="saveDisabled(currentTab) || !userCanEdit">
            {{ 'system-settings.tab.button.save' | translate }}
        </button>
    </div>
    <app-system-setting-ops
        *ngIf="currentTab === OPS"
        [vessel]="vessel"
        [canEditSettings]="userCanEdit"></app-system-setting-ops>
    <app-system-setting-fcu
        *ngIf="currentTab === FCU"
        [vessel]="vessel"
        [canEditSettings]="userCanEdit"></app-system-setting-fcu>
    <app-system-setting-eap
        *ngIf="currentTab === EAP"
        [vessel]="vessel"
        [canEditSettings]="userCanEdit"></app-system-setting-eap>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
